// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TeamTodoDetail_phone_container__Mi\\+ez {
  max-width: 1000px;
  margin: auto;
  padding: 20px;
}

.TeamTodoDetail_phone_title__3TsfN {
  text-align: center;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 20px;
}

.TeamTodoDetail_phone_table_wrapper__nZLLp {
  overflow-x: auto;
}

.TeamTodoDetail_phone_detail_table__VtJDL {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.TeamTodoDetail_phone_table_header__aYNkO {
  background-color: #007bff;
  color: white;
  padding: 12px;
  text-align: left;
  border-bottom: 2px solid #0056b3;
}

.TeamTodoDetail_phone_table_row__EklSE:hover {
  background-color: #f1f1f1;
}

.TeamTodoDetail_phone_table_data__-ACQB {
  padding: 12px;
  border-bottom: 1px solid #ddd;
}

.TeamTodoDetail_phone_no_data__I-JOi {
  text-align: center;
  padding: 20px;
  font-size: 16px;
  font-weight: bold;
  color: #888;
}

/* 🔹 Responsive Design */
@media (max-width: 768px) {
  .TeamTodoDetail_phone_table_header__aYNkO,
  .TeamTodoDetail_phone_table_data__-ACQB {
    padding: 10px;
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .TeamTodoDetail_phone_table_header__aYNkO,
  .TeamTodoDetail_phone_table_data__-ACQB {
    padding: 8px;
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/TeamTodoDetail.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE;;IAEE,aAAa;IACb,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":[".phone_container {\n  max-width: 1000px;\n  margin: auto;\n  padding: 20px;\n}\n\n.phone_title {\n  text-align: center;\n  font-size: 22px;\n  font-weight: bold;\n  margin-bottom: 20px;\n}\n\n.phone_table_wrapper {\n  overflow-x: auto;\n}\n\n.phone_detail_table {\n  width: 100%;\n  border-collapse: collapse;\n  background: #fff;\n  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n}\n\n.phone_table_header {\n  background-color: #007bff;\n  color: white;\n  padding: 12px;\n  text-align: left;\n  border-bottom: 2px solid #0056b3;\n}\n\n.phone_table_row:hover {\n  background-color: #f1f1f1;\n}\n\n.phone_table_data {\n  padding: 12px;\n  border-bottom: 1px solid #ddd;\n}\n\n.phone_no_data {\n  text-align: center;\n  padding: 20px;\n  font-size: 16px;\n  font-weight: bold;\n  color: #888;\n}\n\n/* 🔹 Responsive Design */\n@media (max-width: 768px) {\n  .phone_table_header,\n  .phone_table_data {\n    padding: 10px;\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 480px) {\n  .phone_table_header,\n  .phone_table_data {\n    padding: 8px;\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"phone_container": `TeamTodoDetail_phone_container__Mi+ez`,
	"phone_title": `TeamTodoDetail_phone_title__3TsfN`,
	"phone_table_wrapper": `TeamTodoDetail_phone_table_wrapper__nZLLp`,
	"phone_detail_table": `TeamTodoDetail_phone_detail_table__VtJDL`,
	"phone_table_header": `TeamTodoDetail_phone_table_header__aYNkO`,
	"phone_table_row": `TeamTodoDetail_phone_table_row__EklSE`,
	"phone_table_data": `TeamTodoDetail_phone_table_data__-ACQB`,
	"phone_no_data": `TeamTodoDetail_phone_no_data__I-JOi`
};
export default ___CSS_LOADER_EXPORT___;
